import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { LocaleProvider } from "@/contexts/LocaleContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Splash from "@/pages/Splash";
import Dashboard from "@/pages/Dashboard";
import MuktiHome from "@/pages/MuktiHome";
import LeadRoom from "@/pages/LeadRoom";
import LeadDetail from "@/pages/LeadDetail";
import Investigate from "@/pages/Investigate";
import Advertisements from "@/pages/Advertisements";
import AdDetail from "@/pages/AdDetail";
import PhoneLookup from "@/pages/PhoneLookup";
import ImageLookup from "@/pages/ImageLookup";
import GraphPage from "@/pages/Graph";
import Timeline from "@/pages/Timeline";
import Assistant from "@/pages/Assistant";
import Crawler from "@/pages/Crawler";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import Alerts from "@/pages/Alerts";
import AdminUsers from "@/pages/AdminUsers";
import AuditLog from "@/pages/AuditLog";
import PoliceRoster from "@/pages/PoliceRoster";
import PoliceCapture from "@/pages/PoliceCapture";
import CitizenReportsAdmin from "@/pages/CitizenReportsAdmin";
import CitizenReport, { CitizenReceipt } from "@/pages/CitizenReport";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import IntelGraph from "@/pages/IntelGraph";
import Geographic from "@/pages/Geographic";
import Networks from "@/pages/Networks";
import NetworkDetail from "@/pages/NetworkDetail";
import Search from "@/pages/Search";
import Digest from "@/pages/Digest";

function App() {
  return (
    <AuthProvider>
      <LocaleProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/splash" element={<Splash />} />
          <Route path="/login" element={<Login />} />
          <Route path="/citizen/report" element={<CitizenReport />} />
          <Route path="/citizen/receipt" element={<CitizenReceipt />} />
          <Route path="/citizen/receipt/:id" element={<CitizenReceipt />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<MuktiHome />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="leads" element={<LeadRoom />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="investigate" element={<Investigate />} />
            <Route path="search" element={<Search />} />
            <Route path="digest" element={<Digest />} />
            <Route path="ads" element={<Advertisements />} />
            <Route path="ads/:id" element={<AdDetail />} />
            <Route path="lookup/phone" element={<PhoneLookup />} />
            <Route path="lookup/image" element={<ImageLookup />} />
            <Route path="graph" element={<GraphPage />} />
            <Route path="timeline" element={<Timeline />} />
            <Route path="assistant" element={<Assistant />} />
            <Route path="crawler" element={<Crawler />} />
            <Route path="cases" element={<Cases />} />
            <Route path="cases/:id" element={<CaseDetail />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="intel/entities" element={<Entities />} />
            <Route path="intel/entities/:id" element={<EntityDetail />} />
            <Route path="intel/graph" element={<IntelGraph />} />
            <Route path="intel/geo" element={<Geographic />} />
            <Route path="intel/networks" element={<Networks />} />
            <Route path="intel/networks/:name" element={<NetworkDetail />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/audit" element={<AuditLog />} />
            <Route path="admin/police-roster" element={<PoliceRoster />} />
            <Route path="admin/citizen-reports" element={<CitizenReportsAdmin />} />
            <Route path="capture" element={<PoliceCapture />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </LocaleProvider>
    </AuthProvider>
  );
}

export default App;
